import {API_URL} from "../../../components/config/BaseUrl";

export const CAMPAIGN_MEMBERS_URL = `${API_URL}/wificall/campaign/campaign`;
export const CREATE_CAMPAIGN_URL = `${API_URL}/wificall/campaign/campaign`